const statuses = ['待处理', '处理中', '已报价', '已完成', '已关闭']

function validateSourcing(form, hasMemberPhone) {
  const model = String(form.model || '').trim()
  if (!model) return '请填写产品型号'
  if (model.length > 200) return '产品型号最多200个字符'
  if (form.quantity !== '' && form.quantity !== null && form.quantity !== undefined) {
    const quantity = Number(form.quantity)
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 2147483647) return '数量须为1至2147483647的整数'
  }
  const phone = String(form.contactPhone || '').trim()
  if ((!phone && !hasMemberPhone) || (phone && (!/^\+?[0-9 ()-]{6,30}$/.test(phone) || phone.replace(/\D/g, '').length < 6))) return '请填写有效的联系电话'
  if (String(form.contactName || '').trim().length > 100) return '联系人最多100个字符'
  if (String(form.remark || '').trim().length > 2000) return '备注最多2000个字符'
  return ''
}

module.exports = { statuses, validateSourcing }
